export enum GrantAIFeature {
  AGENT_MODE = 'Agent mode',
  FILE_UPLOAD = 'Add file & split',
  REVIEW_TITLE = 'Review title',
  DRAFT_EXCEPTIONS = 'Draft exceptions & reservations'
}
